// 假的 API 实现，用于开发测试
// 后端接口完成后，这些假数据将被真实的 API 调用替换

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// 模拟 API 响应
const mockApi = {
  // POST /renewal/verify-account
  async post(url, data) {
    await sleep(1000); // 模拟网络延迟
    
    if (url === '/renewal/verify-account') {
      // 模拟账户验证
      if (data.email && data.password) {
        // 假设所有账户都验证成功
        return {
          data: {
            success: true,
            data: {
              email: data.email,
              accountType: 'ChatGPT Plus',
              status: 'active',
              expiryDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString() // 30天后
            }
          }
        };
      } else {
        return {
          data: {
            success: false,
            message: '邮箱或密码不能为空'
          }
        };
      }
    }
    
    if (url === '/renewal/verify-card') {
      // 模拟卡密验证
      if (data.cardCode && data.cardCode.length === 16) {
        // 假设卡密格式正确就验证成功
        return {
          data: {
            success: true,
            data: {
              cardCode: data.cardCode,
              productId: data.productId,
              duration: '1个月',
              value: 20,
              status: 'unused'
            }
          }
        };
      } else {
        return {
          data: {
            success: false,
            message: '卡密格式不正确，请输入16位卡密'
          }
        };
      }
    }
    
    if (url === '/renewal/process') {
      // 模拟续费处理
      const orderId = 'ORD' + Date.now();
      return {
        data: {
          success: true,
          data: {
            orderId: orderId,
            status: 'processing',
            message: '续费处理中'
          }
        }
      };
    }
    
    // 默认返回
    return {
      data: {
        success: false,
        message: '未知的请求'
      }
    };
  },
  
  // GET /renewal/status/:orderId
  async get(url) {
    await sleep(500); // 模拟网络延迟
    
    if (url.startsWith('/renewal/status/')) {
      const orderId = url.split('/').pop();
      
      // 模拟不同的续费状态
      // 随机决定成功或失败（90%成功率）
      const isSuccess = Math.random() > 0.1;
      
      // 模拟处理时间（前3次查询返回processing，之后返回最终状态）
      const queryCount = parseInt(localStorage.getItem(`renewal_query_${orderId}`) || '0');
      localStorage.setItem(`renewal_query_${orderId}`, (queryCount + 1).toString());
      
      if (queryCount < 3) {
        return {
          data: {
            success: true,
            data: {
              orderId: orderId,
              status: 'processing',
              message: '续费处理中，请稍候...'
            }
          }
        };
      } else {
        // 清理查询计数
        localStorage.removeItem(`renewal_query_${orderId}`);
        
        if (isSuccess) {
          return {
            data: {
              success: true,
              data: {
                orderId: orderId,
                status: 'success',
                message: '续费成功',
                expiryDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString()
              }
            }
          };
        } else {
          return {
            data: {
              success: true,
              data: {
                orderId: orderId,
                status: 'failed',
                message: '续费失败：账户验证失败，请检查账户信息'
              }
            }
          };
        }
      }
    }
    
    // 默认返回
    return {
      data: {
        success: false,
        message: '未知的请求'
      }
    };
  }
};

export default mockApi;